var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraseMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54808 5.83357L11.1346 0.802221C12.1087 -0.267407 13.8096 -0.267407 14.7837 0.802221L19.7249 6.22319C20.729 7.32468 20.729 9.1171 19.7249 10.2186L15.1409 15.2481L6.54808 5.83357ZM12.4684 18.1794L13.9653 16.5371L5.37252 7.1235L1.25304 11.6432C0.248985 12.7447 0.248985 14.5372 1.25304 15.6386L5.22765 20H20.5V18.1794H12.4684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraseMobile);
export default __webpack_public_path__ + "static/media/eraseMobile.0d173767a8620101ae656c16f76eb88b.svg";
export { ForwardRef as ReactComponent };